import C from 'classnames';
import * as React from 'react';
import { TestingProps } from '../../Types/Testing';
interface IModalCardProps extends TestingProps {
  children?: React.ReactNode;
  className?: string;
}

export const ModalCard: React.FunctionComponent<IModalCardProps> = (props) => {
  return (
    <div
      className={C('modal-card', 'card', props.className)}
      data-testid={props.testId}
    >
      {props.children}
    </div>
  );
};
